<script setup lang="ts">
import TrafficPriceItem from "~/components/sx/prices/TrafficPriceItem.vue";
import {type IPromiseTariff, useCustomTariffStore} from "~/stores/useCustomTariffStore";
import {UiButton} from "@common/ui-kit";
import {capitalize} from "vue";

const { t } = useI18n();
const { tariffs: storeTariffs } = useCustomTariffStore();

const hiddenTariffsVisible = ref(false);

const tariffs = computed(() => {
  return storeTariffs.value.promise.slice(0, 2);
});

const tariffsHidden = computed(() => {
  return storeTariffs.value.promise.slice(2);
})

const visibleTariffs = computed(() => {
  return hiddenTariffsVisible.value
    ? tariffs.value.concat(tariffsHidden.value)
    : tariffs.value;
});

const getTrafficPriceItemTag = (item: IPromiseTariff, index: number) => {
  if (index > 1) return;
  return item.is_default ? t('pages.home.prices.common.initialTariff') : t('pages.home.prices.common.mostProfitable');
};
</script>

<template>
<div class="prices-traffic">
  <div class="prices-traffic__inner">
    <TransitionGroup
      v-if="visibleTariffs.length"
      name="fade-list"
      tag="div"
      class="prices-traffic__content"
    >
      <TrafficPriceItem
        v-for="(item, index) in visibleTariffs"
        :key="item.id"
        :item="item"
        :tag="getTrafficPriceItemTag(item, index)"
      />
    </TransitionGroup>
  </div>

  <div class="prices-traffic__controls">
    <UiButton
      class="prices-traffic__btn"
      @click="hiddenTariffsVisible = !hiddenTariffsVisible"
    >
      <span class="default-tag">
        {{ hiddenTariffsVisible ? capitalize($t('pages.home.prices.common.hide')) : `${capitalize($t('pages.home.prices.common.showAllTariffs'))} (${tariffsHidden.length})`  }}
      </span>
    </UiButton>
  </div>
</div>
</template>

<style scoped lang="scss">
.prices-traffic {
  display: flex;
  flex-direction: column;
  gap: 24px;
  &__content {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  &__controls {
    display: flex;
    justify-content: center;
  }
  &__btn {
    background: #fff;
    color: #000;
    height: 44px;
    border-radius: 52px;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0;
    &:hover {
      background: #eeeeee !important;
    }
  }
}

.fade-list-enter-active,
.fade-list-leave-active {
  transition: all 0.4s ease;
}

.fade-list-enter-from,
.fade-list-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

@media (max-width: 1199px) {
  .prices-traffic {
    &__content {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
}
</style>